module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-1-orange-33db8b16a84386a89cad92a7462c9ae1.svg";